import TogglePartnerLocations from './TogglePartnerLocations';

export default TogglePartnerLocations;
